"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LazyPromise = void 0;
class LazyPromise {
    constructor(_factory, initial = undefined) {
        this._factory = _factory;
        this.initial = initial;
        this._instance = undefined;
        this._busy = null;
        this._promise = null;
        this.setInstance = (res) => {
            this._busy = false;
            this._instance = res || null;
            // keep this._promise to allow to re-use it outside
        };
        this.dispose = () => this.reset();
        this._instance = initial;
    }
    get busy() { return this._busy || false; }
    get hasValue() { return this._busy === false; }
    get promise() {
        this.ensureInstanceLoading();
        return this._promise;
    }
    get value() {
        this.ensureInstanceLoading();
        return this._instance;
    }
    ensureInstanceLoading() {
        if (this._busy === null) {
            this._busy = true;
            this._promise = this._factory();
            this._promise.then(this.setInstance);
        }
    }
    reset() {
        this._busy = null;
        this._instance = this.initial;
        this._promise = null;
    }
}
exports.LazyPromise = LazyPromise;
//# sourceMappingURL=promise.js.map